import React, { Fragment } from "react";
import Wrapper from "./Wrapper";
import Label from "./Label";
import ErrorBlock from "./ErrorBlock";
import HelpBlock from "./HelpBlock";
const StandardView = (props) => (<Wrapper className={props.className} showError={props.error != null}>
		<label className="label" htmlFor={props.id}>
			<Label label={props.label} required={props.required}/>
			{props.error != null && (<Fragment>
					{" "}
					<ErrorBlock id={props.errorId || null} error={props.error}/>
				</Fragment>)}
			{props.help != null && (<HelpBlock id={props.helpId || null} help={props.help}/>)}
		</label>
		{props.children}
	</Wrapper>);
export default StandardView;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/StandardView.tsx